import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const ARTICLE_IMAGES: Record<string, string> = {
  'how-to-access-91-web': 'https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20a%20clean%20web%20browser%20interface%20with%20login%20page%2C%20minimalist%20desk%20setup%20with%20warm%20ambient%20lighting%2C%20soft%20natural%20light%20from%20window%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20warm%20neutral%20tones&width=800&height=500&seq=article-access-web&orientation=landscape',
  'fix-91-web-not-opening': 'https://readdy.ai/api/search-image?query=A%20person%20troubleshooting%20on%20laptop%20with%20browser%20error%20page%20displayed%2C%20warm%20modern%20home%20office%20setting%20with%20plants%20on%20desk%2C%20soft%20daylight%20through%20blinds%2C%20editorial%20atmosphere%2C%20warm%20beige%20and%20wood%20tones&width=800&height=500&seq=article-fix&orientation=landscape',
  '91-web-new-features-2026': 'https://readdy.ai/api/search-image?query=Modern%20clean%20web%20interface%20design%20showcase%20on%20a%20large%20monitor%20screen%2C%20bright%20airy%20creative%20office%20environment%2C%20minimal%20Scandinavian%20style%20desk%20setup%2C%20natural%20lighting%2C%20warm%20neutral%20color%20palette%2C%20professional%20tech%20atmosphere&width=800&height=500&seq=article-features&orientation=landscape',
  '91-web-speed-optimization': 'https://readdy.ai/api/search-image?query=Close-up%20of%20a%20laptop%20keyboard%20with%20hands%20typing%2C%20speed%20and%20efficiency%20theme%2C%20modern%20minimalist%20desk%20setup%2C%20soft%20warm%20lighting%2C%20shallow%20depth%20of%20field%2C%20warm%20beige%20and%20cream%20tones%2C%20professional%20editorial%20photography&width=800&height=500&seq=article-speed&orientation=landscape',
};

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-sm">
              提供最新的91网页版入口教程和使用指南
            </p>
          </div>
          <Link
            to="/category/access-tutorial"
            className="hidden sm:flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={ARTICLE_IMAGES[article.slug] || ARTICLE_IMAGES['how-to-access-91-web']}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs text-foreground-600">
                  {article.categoryName}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-medium text-foreground-900 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟阅读
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/access-tutorial"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}